import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DocumentConfig, VendorDocument } from '../../../core/models/domain.models';
import { ApiService } from '../../../core/services/api.service';

@Injectable({ providedIn: 'root' })
export class VendorDocumentsService {
  private readonly http = inject(HttpClient);
  private readonly api = inject(ApiService);

  listConfigs() {
    return this.api.get<DocumentConfig[]>('/api/document-configs');
  }

  getConfig(id: string) {
    return this.api.get<DocumentConfig>(`/api/document-configs/${id}`);
  }

  createConfig(payload: Partial<DocumentConfig>) {
    return this.api.post<DocumentConfig>('/api/document-configs', payload);
  }

  updateConfig(id: string, payload: Partial<DocumentConfig>) {
    return this.api.patch<DocumentConfig>(`/api/document-configs/${id}`, payload);
  }

  deleteConfig(id: string) {
    return this.api.delete<{ message: string }>(`/api/document-configs/${id}`);
  }

  listVendorDocuments(vendorId: string, loaId?: string | null, unassignedOnly: boolean = false) {
    const params: Record<string, string> = {};
    if (loaId) params['loa_id'] = loaId;
    if (unassignedOnly) params['unassigned_only'] = 'true';
    return this.api.get<VendorDocument[]>(
      `/api/vendors/${vendorId}/documents`,
      Object.keys(params).length ? params : undefined,
    );
  }

  uploadVendorDocuments(vendorId: string, documentType: string, files: File[], loaId?: string | null) {
    const formData = new FormData();
    formData.append('document_type', documentType);
    if (loaId) formData.append('loa_id', loaId);
    files.forEach((file) => formData.append('files', file));
    return this.http.post<VendorDocument[]>(this.api.resolve(`/api/vendors/${vendorId}/documents`), formData, {
      withCredentials: true,
    });
  }

  deleteDocument(id: string) {
    return this.api.delete<{ message: string }>(`/api/documents/${id}`);
  }

  downloadUrl(id: string): string {
    return this.api.resolve(`/api/documents/${id}/download`);
  }
}
